<template>
<v-container>
    <div  flat color="transparent">
            <v-layout>
                <v-flex xs2>
                    <v-btn color="blue lighten-1" dark round @click="gotoDashboard">Dashboard</v-btn>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs2>
                    <v-btn :color="page ? 'primary' : ''" flat round>Connect to Page</v-btn>
                </v-flex>
                <!-- <v-flex xs1>
                    <v-btn disabled flat>Menu</v-btn>
                </v-flex> 
                 <v-flex xs2>
                    <v-btn disabled flat>GetStarted note</v-btn>
                </v-flex>
                 <v-flex xs2>
                    <v-btn disabled flat>Whitelistings</v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-btn disabled flat>Publish bot</v-btn>
                </v-flex>     -->
            </v-layout>
    </div>
    <page v-if="page"> </page>
</v-container>
</template>

<script>
import page from './Display-settings-new-page.vue'

export default {
    components:{
        page
    },
    data(){
        return{
            page:true
        }
    },
    methods:{
        fetchData(){
            this.$store.dispatch('aFetchfbdata')
        },
        gotoDashboard(){
        this.$router.push("/dashboard")
        }
    },
    created(){
        this.fetchData()
    }    
}
</script>
